module.exports = __webpack_public_path__ + "static/media/car14.f0c94609.png";